export const enum AutoincrementType {
    Organisation = "organisation",
    Project = "project"
}
